/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputUavMissionShootdown } from './OutputUavMissionShootdown';
import {
    OutputUavMissionShootdownFromJSON,
    OutputUavMissionShootdownFromJSONTyped,
    OutputUavMissionShootdownToJSON,
} from './OutputUavMissionShootdown';
import type { OutputUavWaypoint } from './OutputUavWaypoint';
import {
    OutputUavWaypointFromJSON,
    OutputUavWaypointFromJSONTyped,
    OutputUavWaypointToJSON,
} from './OutputUavWaypoint';

/**
 * 
 * @export
 * @interface OutputUavMission
 */
export interface OutputUavMission {
    /**
     * ActiveUntil — кінець вікна польоту (RFC3339, ComputeUavMissionActiveUntil). null = вікно
     * не розпарсили. Разом з FlightDate/CreatedAt дає фронту ту саму ознаку "заявка ще активна",
     * що й mode=active у GetUavMissionsListHandler — realtime-оновлення не повертають у
     * дашборд заявку, яка вже пішла в історію.
     * @type {string}
     * @memberof OutputUavMission
     */
    activeUntil?: string;
    /**
     * AirborneAt — момент підйому борта в поточному вильоті (RFC3339). Від нього диспетчерська
     * рахує наліт і залишок до ліміту ТТХ (MaxDurationMin), бо StatusChangedAt для цього не
     * годиться: у баражуванні борт годинами стоїть у фазі "Небо" з фіксованим часом фази.
     * null = борт на землі.
     * @type {string}
     * @memberof OutputUavMission
     */
    airborneAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    altitude?: string;
    /**
     * AuthorElementLogin — Matrix-логін того, хто подав заявку в Element.
     * Порожньо для заявок, створених вручну через UI.
     * @type {string}
     * @memberof OutputUavMission
     */
    authorElementLogin?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    contactAnchorLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    contactAnchorLng?: number;
    /**
     * CreatedAt — момент подачі заявки (RFC3339). Резервна "ефективна дата" для заявок без
     * flight_date, за якою бекенд розводить active/history.
     * @type {string}
     * @memberof OutputUavMission
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    destinationArea?: string;
    /**
     * EwReportedAt — момент останньої доповіді екіпажу про ворожий РЕБ у треді заявки
     * (RFC3339). null = доповідей не було. Диспетчерська за ним пульсує бортом на мапі.
     * @type {string}
     * @memberof OutputUavMission
     */
    ewReportedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    flightDate?: string;
    /**
     * 
     * @type {Array<OutputUavWaypoint>}
     * @memberof OutputUavMission
     */
    flightPath?: Array<OutputUavWaypoint>;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    launchSite?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    loiterHeadingDeg?: number;
    /**
     * Район баражування розвідника, що працює до ЛБЗ: центр, радіус (м) та азимут довгої осі
     * петлі (градуси, паралельно лінії фронту). null = району немає — борт долітає до кінця
     * треку і розвертається, як у бомбера.
     * @type {number}
     * @memberof OutputUavMission
     */
    loiterLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    loiterLng?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    loiterRadiusM?: number;
    /**
     * MaxDurationMin — заявлений у ТТХ час роботи засобу, хв (uav_platforms.max_duration_min).
     * Ліміт тривалості вильоту: за цей час борт має повернутися в статус "Земля". null =
     * платформа не розпізнана або ТТХ не заповнено — тоді диспетчерська наліт не обмежує.
     * @type {number}
     * @memberof OutputUavMission
     */
    maxDurationMin?: number;
    /**
     * ParseStatus — стан LLM-парсингу raw_message: pending|extracted|parsed|needs_review|failed.
     * UI за ним показує стан картки (⏳ парситься / не розпізнано) замість структурованих полів.
     * @type {string}
     * @memberof OutputUavMission
     */
    parseStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    posOverrideAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    posOverrideDir?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    posOverrideDist?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    rawMessage?: string;
    /**
     * ReturnMinutes — розрахунковий переліт від дальньої точки маршруту до точки запуску, хв
     * (довжина треку / швидкість борта). За ним диспетчерська показує, коли пора завертати
     * додому, а воркер автоповернення сам переводить заявку в "ЛБЗ назад". null = маршруту
     * в заявці ще немає.
     * @type {number}
     * @memberof OutputUavMission
     */
    returnMinutes?: number;
    /**
     * Shootdowns — журнал збитих бортів по заявці (0..N, seq 1,2,3... — резервний борт
     * продовжує ТУ Ж заявку). Кожен запис виставляє Status в "landed" в момент фіксації.
     * @type {Array<OutputUavMissionShootdown>}
     * @memberof OutputUavMission
     */
    shootdowns?: Array<OutputUavMissionShootdown>;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    speedKmh?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    statusChangedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    timeWindow?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    uavCrewCallsign?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    uavCrewId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    uavPlatformId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    uavPlatformName?: string;
    /**
     * UavPlatformType — recon | bomber | kamikaze. Камікадзе не повертається:
     * анімація диспетчерської зупиняє борт на цілі, а не розвертає назад.
     * @type {string}
     * @memberof OutputUavMission
     */
    uavPlatformType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMission
     */
    uavUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    uavUnitName?: string;
    /**
     * UnreadNotesCount — скільки нотаток треду поточний користувач ще не бачив (0, якщо
     * дочитав або треду нема). Рахується лише у списку заявок — саме там маркер і потрібен;
     * у broadcast'ах Centrifugo завжди 0, бо подія спільна для всіх отримувачів.
     * @type {number}
     * @memberof OutputUavMission
     */
    unreadNotesCount?: number;
    /**
     * UsesDroneID — чи вмикає екіпаж Drone ID (Remote ID). null = у заявці не вказано.
     * @type {boolean}
     * @memberof OutputUavMission
     */
    usesDroneId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMission
     */
    workType?: string;
}

/**
 * Check if a given object implements the OutputUavMission interface.
 */
export function instanceOfOutputUavMission(value: object): boolean {
    return true;
}

export function OutputUavMissionFromJSON(json: any): OutputUavMission {
    return OutputUavMissionFromJSONTyped(json, false);
}

export function OutputUavMissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMission {
    if (json == null) {
        return json;
    }
    return {
        
        'activeUntil': json['activeUntil'] == null ? undefined : json['activeUntil'],
        'airborneAt': json['airborneAt'] == null ? undefined : json['airborneAt'],
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'authorElementLogin': json['authorElementLogin'] == null ? undefined : json['authorElementLogin'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'contactAnchorLat': json['contactAnchorLat'] == null ? undefined : json['contactAnchorLat'],
        'contactAnchorLng': json['contactAnchorLng'] == null ? undefined : json['contactAnchorLng'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'destinationArea': json['destinationArea'] == null ? undefined : json['destinationArea'],
        'ewReportedAt': json['ewReportedAt'] == null ? undefined : json['ewReportedAt'],
        'flightDate': json['flightDate'] == null ? undefined : json['flightDate'],
        'flightPath': json['flightPath'] == null ? undefined : ((json['flightPath'] as Array<any>).map(OutputUavWaypointFromJSON)),
        'id': json['id'] == null ? undefined : json['id'],
        'launchSite': json['launchSite'] == null ? undefined : json['launchSite'],
        'loiterHeadingDeg': json['loiterHeadingDeg'] == null ? undefined : json['loiterHeadingDeg'],
        'loiterLat': json['loiterLat'] == null ? undefined : json['loiterLat'],
        'loiterLng': json['loiterLng'] == null ? undefined : json['loiterLng'],
        'loiterRadiusM': json['loiterRadiusM'] == null ? undefined : json['loiterRadiusM'],
        'maxDurationMin': json['maxDurationMin'] == null ? undefined : json['maxDurationMin'],
        'parseStatus': json['parseStatus'] == null ? undefined : json['parseStatus'],
        'posOverrideAt': json['posOverrideAt'] == null ? undefined : json['posOverrideAt'],
        'posOverrideDir': json['posOverrideDir'] == null ? undefined : json['posOverrideDir'],
        'posOverrideDist': json['posOverrideDist'] == null ? undefined : json['posOverrideDist'],
        'rawMessage': json['rawMessage'] == null ? undefined : json['rawMessage'],
        'returnMinutes': json['returnMinutes'] == null ? undefined : json['returnMinutes'],
        'shootdowns': json['shootdowns'] == null ? undefined : ((json['shootdowns'] as Array<any>).map(OutputUavMissionShootdownFromJSON)),
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusChangedAt': json['statusChangedAt'] == null ? undefined : json['statusChangedAt'],
        'timeWindow': json['timeWindow'] == null ? undefined : json['timeWindow'],
        'uavCrewCallsign': json['uavCrewCallsign'] == null ? undefined : json['uavCrewCallsign'],
        'uavCrewId': json['uavCrewId'] == null ? undefined : json['uavCrewId'],
        'uavPlatformId': json['uavPlatformId'] == null ? undefined : json['uavPlatformId'],
        'uavPlatformName': json['uavPlatformName'] == null ? undefined : json['uavPlatformName'],
        'uavPlatformType': json['uavPlatformType'] == null ? undefined : json['uavPlatformType'],
        'uavUnitId': json['uavUnitId'] == null ? undefined : json['uavUnitId'],
        'uavUnitName': json['uavUnitName'] == null ? undefined : json['uavUnitName'],
        'unreadNotesCount': json['unreadNotesCount'] == null ? undefined : json['unreadNotesCount'],
        'usesDroneId': json['usesDroneId'] == null ? undefined : json['usesDroneId'],
        'workType': json['workType'] == null ? undefined : json['workType'],
    };
}

export function OutputUavMissionToJSON(value?: OutputUavMission | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'activeUntil': value['activeUntil'],
        'airborneAt': value['airborneAt'],
        'altitude': value['altitude'],
        'authorElementLogin': value['authorElementLogin'],
        'comment': value['comment'],
        'contactAnchorLat': value['contactAnchorLat'],
        'contactAnchorLng': value['contactAnchorLng'],
        'createdAt': value['createdAt'],
        'destinationArea': value['destinationArea'],
        'ewReportedAt': value['ewReportedAt'],
        'flightDate': value['flightDate'],
        'flightPath': value['flightPath'] == null ? undefined : ((value['flightPath'] as Array<any>).map(OutputUavWaypointToJSON)),
        'id': value['id'],
        'launchSite': value['launchSite'],
        'loiterHeadingDeg': value['loiterHeadingDeg'],
        'loiterLat': value['loiterLat'],
        'loiterLng': value['loiterLng'],
        'loiterRadiusM': value['loiterRadiusM'],
        'maxDurationMin': value['maxDurationMin'],
        'parseStatus': value['parseStatus'],
        'posOverrideAt': value['posOverrideAt'],
        'posOverrideDir': value['posOverrideDir'],
        'posOverrideDist': value['posOverrideDist'],
        'rawMessage': value['rawMessage'],
        'returnMinutes': value['returnMinutes'],
        'shootdowns': value['shootdowns'] == null ? undefined : ((value['shootdowns'] as Array<any>).map(OutputUavMissionShootdownToJSON)),
        'speedKmh': value['speedKmh'],
        'status': value['status'],
        'statusChangedAt': value['statusChangedAt'],
        'timeWindow': value['timeWindow'],
        'uavCrewCallsign': value['uavCrewCallsign'],
        'uavCrewId': value['uavCrewId'],
        'uavPlatformId': value['uavPlatformId'],
        'uavPlatformName': value['uavPlatformName'],
        'uavPlatformType': value['uavPlatformType'],
        'uavUnitId': value['uavUnitId'],
        'uavUnitName': value['uavUnitName'],
        'unreadNotesCount': value['unreadNotesCount'],
        'usesDroneId': value['usesDroneId'],
        'workType': value['workType'],
    };
}

